import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { logout } from 'slice/userSlice';
import { useDispatch } from 'react-redux';
import { IoPersonCircleSharp } from "react-icons/io5";
import { FaUsers, FaImages } from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import { RiMedicineBottleLine, RiLayoutMasonryLine } from "react-icons/ri"; // RiVideoLine
import { toast } from 'react-toastify';
import { getRequest } from 'apis/ApiInstence';
import logo from '../asserts/img/logo.png'

// NOTE: socket is intentionally NOT created at module level.
// It is created inside the component to allow proper cleanup.

const LS_CONTACT = 'contactus_last_seen';

const Layout = ({ children }) => {
  const [toggled, setToggle] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [contactUnread, setContactUnread] = useState(0);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isActive = (path) => pathname === path || pathname.startsWith(path + '/');
  const isSegmentActive = (segment) => pathname.includes(segment);

  const adminName = localStorage.getItem('adminName') || 'Admin';

  // socket.io temporarily disabled (CORS errors on api.yashsoftsolution.com)

  const getAuthHeaders = () => {
    const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
    return { headers: { Authorization: `Bearer ${token}` } };
  };

  const fetchUnreadCounts = useCallback(async () => {
    try {
      const contactRes = await getRequest('contactus?limit=500', getAuthHeaders());

      const contactLastSeen = localStorage.getItem(LS_CONTACT);

      if (contactRes.data.success) {
        const items = Array.isArray(contactRes.data.data) ? contactRes.data.data : [];
        const count = contactLastSeen
          ? items.filter((item) => new Date(item.createdAt) > new Date(contactLastSeen)).length
          : items.length;
        setContactUnread(count);
      }
    } catch {
      // silent fail
    }
  }, []);

  const markContactSeen = () => {
    localStorage.setItem(LS_CONTACT, new Date().toISOString());
    setContactUnread(0);
  };

  const handleTabClick = (tabName) => {
    setOpenMenu(openMenu === tabName ? null : tabName);
  };

  useEffect(() => {
    if (pathname.includes('contactus')) setOpenMenu('contactus');
    else if (pathname.includes('banner')) setOpenMenu('banner');
    else if (pathname.includes('events')) setOpenMenu('events');
    else if (pathname.includes('blogs')) setOpenMenu('blogs');
    else if (pathname.includes('testimonials')) setOpenMenu('testimonials');
    else if (pathname.includes('departments')) setOpenMenu('departments');
    else if (pathname.includes('doctors')) setOpenMenu('doctors');
    else if (pathname.includes('reports')) setOpenMenu('reports');
    else if (pathname.includes('leadership')) setOpenMenu('leadership');
    else if (pathname.includes('sitesetup')) setOpenMenu('sitesetup');
    else if (pathname.includes('gallery')) setOpenMenu('gallery');
  }, [pathname]);

  useEffect(() => {
    fetchUnreadCounts();
    const interval = setInterval(fetchUnreadCounts, 60000);
    return () => clearInterval(interval);
  }, [fetchUnreadCounts]);

  const logoutHandler = async () => {
    localStorage.removeItem('userToken');
    sessionStorage.removeItem('userToken');
    dispatch(logout());
    navigate('/signin');
    toast.success('Logged out successfully');
  };

  const handleKeyDown = (e, action) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      action();
    }
  };

  return (
    <div id="wrapper">
      <ul className={toggled ? 'navbar-nav sidebar sidebar-dark toggled' : 'navbar-nav sidebar sidebar-dark accordion'} id="accordionSidebar">
        <Link className="sidebar-brand d-flex align-items-center p-4 mb-2" to="/" style={{ textDecoration: 'none' }}>
          <div className="sidebar-brand-icon">
            <img src={logo} alt="Graaho" style={{ width: '200px', height: 'auto' }} />
          </div>
        </Link>

        <div className="sidebar-heading">MAIN MENU</div>
        <li className={`nav-item ${isActive('/dashboard') ? 'active' : ''}`}>
          <Link className="nav-link" to="/dashboard">
            <MdDashboard /> <span>Dashboard</span>
          </Link>
        </li>

        <div className="sidebar-heading">MANAGEMENT</div>


{/* report */}
        <li className={`nav-item ${isSegmentActive('reports') ? 'active' : ''}`}>
          <button type="button" className="nav-link w-100 border-0 bg-transparent text-left" onClick={() => handleTabClick('reports')}>
            <RiLayoutMasonryLine /> <span>All Reports</span>
          </button>
          <div className={`collapse ${openMenu === 'reports' ? 'show' : ''}`}>
            <div className="collapse-inner">
              <Link className="collapse-item" to="/reports">Report List</Link>
              <Link className="collapse-item" to="/reports/add">Add Report</Link>
            </div>
          </div>
        </li>

{/* benner */}
        <li className={`nav-item ${isSegmentActive('banner') ? 'active' : ''}`}>
          <button type="button" className="nav-link w-100 border-0 bg-transparent text-left" onClick={() => handleTabClick('banner')}>
            <RiLayoutMasonryLine /> <span>Banners</span>
          </button>
          <div className={`collapse ${openMenu === 'banner' ? 'show' : ''}`}>
            <div className="collapse-inner">
              <Link className="collapse-item" to="/banner">Banner List</Link>
              <Link className="collapse-item" to="/banner/add">Add Banner</Link>
            </div>
          </div>
        </li>

{/* blogs */}
 {/* <li className={`nav-item ${isSegmentActive('blogs') ? 'active' : ''}`}>
          <button type="button" className="nav-link w-100 border-0 bg-transparent text-left" onClick={() => handleTabClick('blogs')}>
            <RiMedicineBottleLine /> <span>Blogs</span>
          </button>
          <div className={`collapse ${openMenu === 'blogs' ? 'show' : ''}`}>
            <div className="collapse-inner">
              <Link className="collapse-item" to="/blogs">Blogs</Link>
              <Link className="collapse-item" to="/blogs/add">Add Blog</Link>
            </div>
          </div>
        </li>        */}
        
{/* contect */}
        <li className={`nav-item ${isSegmentActive('contactus') ? 'active' : ''}`}>
          <button type="button" className="nav-link w-100 border-0 bg-transparent text-left" onClick={() => handleTabClick('contactus')}>
            <FaUsers /> <span>Contact Us</span>
            {contactUnread > 0 && <span className="badge badge-danger ml-auto">{contactUnread}</span>}
          </button>
          <div className={`collapse ${openMenu === 'contactus' ? 'show' : ''}`}>
            <div className="collapse-inner">
              <Link className="collapse-item" to="/contactus" onClick={markContactSeen}>All Contact Us</Link>
            </div>
          </div>
        </li>

{/* department */}
        <li className={`nav-item ${isSegmentActive('departments') ? 'active' : ''}`}>
          <button type="button" className="nav-link w-100 border-0 bg-transparent text-left" onClick={() => handleTabClick('departments')}>
            <RiLayoutMasonryLine /> <span>Departments</span>
          </button>
          <div className={`collapse ${openMenu === 'departments' ? 'show' : ''}`}>
            <div className="collapse-inner">
              <Link className="collapse-item" to="/departments">Department List</Link>
              <Link className="collapse-item" to="/departments/add">Add Department</Link>
            </div>
          </div>
        </li>

{/* docters */}
        <li className={`nav-item ${isSegmentActive('doctors') ? 'active' : ''}`}>
          <button type="button" className="nav-link w-100 border-0 bg-transparent text-left" onClick={() => handleTabClick('doctors')}>
            <RiLayoutMasonryLine /> <span>Doctors</span>
          </button>
          <div className={`collapse ${openMenu === 'doctors' ? 'show' : ''}`}>
            <div className="collapse-inner">
              <Link className="collapse-item" to="/doctors">Doctor List</Link>
              <Link className="collapse-item" to="/doctors/add">Add Doctor</Link>
            </div>
          </div>
        </li>

{/* event */}
        <li className={`nav-item ${isSegmentActive('events') ? 'active' : ''}`}>
          <button type="button" className="nav-link w-100 border-0 bg-transparent text-left" onClick={() => handleTabClick('events')}>
            <RiLayoutMasonryLine /> <span>Events</span>
          </button>
          <div className={`collapse ${openMenu === 'events' ? 'show' : ''}`}>
            <div className="collapse-inner">
              <Link className="collapse-item" to="/events">Event List</Link>
              <Link className="collapse-item" to="/events/add">Add Event</Link>
            </div>
          </div>
        </li>

{/* gallery */}
        <li className={`nav-item ${isSegmentActive('gallery') ? 'active' : ''}`}>
          <button type="button" className="nav-link w-100 border-0 bg-transparent text-left" onClick={() => handleTabClick('gallery')}>
            <FaImages /> <span>Gallery</span>
          </button>
          <div className={`collapse ${openMenu === 'gallery' ? 'show' : ''}`}>
            <div className="collapse-inner">
              <Link className="collapse-item" to="/gallery">Gallery List</Link>
              <Link className="collapse-item" to="/gallery/add">Add Image</Link>
            </div>
          </div>
        </li>

{/* leaders */}
        <li className={`nav-item ${isSegmentActive('leadership') ? 'active' : ''}`}>
          <button type="button" className="nav-link w-100 border-0 bg-transparent text-left" onClick={() => handleTabClick('leadership')}>
            <RiLayoutMasonryLine /> <span>Leaders</span>
          </button>
          <div className={`collapse ${openMenu === 'leadership' ? 'show' : ''}`}>
            <div className="collapse-inner">
              <Link className="collapse-item" to="/leadership">Leader List</Link>
              <Link className="collapse-item" to="/leadership/add">Add Leader</Link>
            </div>
          </div>
        </li>

{/* video */}
        {/* <li className="nav-item">
          <Link className="nav-link" to="/live-video">
            <RiVideoLine /> <span>Live Videos</span>
          </Link>
        </li> */}

{/* sitesetup */}
        <li className={`nav-item ${isSegmentActive('sitesetup') ? 'active' : ''}`}>
          <button type="button" className="nav-link w-100 border-0 bg-transparent text-left" onClick={() => handleTabClick('sitesetup')}>
            <RiLayoutMasonryLine /> <span>Site Setup</span>
          </button>
          <div className={`collapse ${openMenu === 'sitesetup' ? 'show' : ''}`}>
            <div className="collapse-inner">
              <Link className="collapse-item" to="/sitesetup/social-media">Social Media</Link>
              <Link className="collapse-item" to="/sitesetup/holiday-calendar">Holiday Calendar</Link>
              <Link className="collapse-item" to="/sitesetup/websitelinks">Website Links</Link>
              <Link className="collapse-item" to="/sitesetup/announcements">Announcements</Link>
            </div>
          </div>
        </li>

{/* testimonials */}
        <li className={`nav-item ${isSegmentActive('testimonials') ? 'active' : ''}`}>
          <button type="button" className="nav-link w-100 border-0 bg-transparent text-left" onClick={() => handleTabClick('testimonials')}>
            <RiMedicineBottleLine /> <span>Testimonials</span>
          </button>
          <div className={`collapse ${openMenu === 'testimonials' ? 'show' : ''}`}>
            <div className="collapse-inner">
              <Link className="collapse-item" to="/testimonials">Testimonials List</Link>
              <Link className="collapse-item" to="/testimonials/add">Add Testimonial</Link>
            </div>
          </div>
        </li>

        <div className="text-center d-none d-md-inline mt-auto py-4">
          <button 
            type="button" 
            className="rounded-circle border-0" 
            onClick={() => setToggle(!toggled)} 
            style={{ background: '#f1f5f9', color: 'var(--text-main)', width: '40px', height: '40px' }}
          >
            <i className={toggled ? "fa fa-chevron-right" : "fa fa-chevron-left"}></i>
          </button>
        </div>
      </ul>

      <div id="content-wrapper" className="d-flex flex-column" style={{ background: 'var(--bg-main)', flexGrow: 1 }}>
        <div id="content">
          <nav className="navbar navbar-expand topbar mb-4 static-top">
            <button 
              type="button"
              onClick={() => setToggle(!toggled)} 
              className="btn btn-link d-md-none rounded-circle mr-3" 
              style={{ color: 'var(--text-body)' }}
            >
              <i className="fa fa-bars"></i>
            </button>
            <div className="d-none d-md-block">
              <h6 className="mb-0 font-weight-bold" style={{ color: 'var(--primary)', fontSize: '1rem' }}>
                Welcome Admin Dashbord,
              </h6>
              {/* <span className="text-muted small">Jabalpur, Madhya Pradesh &bull; {adminName}</span> */}
            </div>
            <div className="flex-grow-1"></div>
            <ul className="navbar-nav align-items-center">
              <li className="nav-item dropdown no-arrow">
                <div 
                  className="dropdown-toggle d-flex align-items-center p-1 cursor-pointer" 
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  onKeyDown={(e) => handleKeyDown(e, () => setDropdownOpen(!dropdownOpen))}
                  role="button"
                  tabIndex={0}
                >
                  <div style={{ width: '38px', height: '38px', background: 'var(--primary)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <IoPersonCircleSharp size={28} style={{ color: "white" }} />
                  </div>
                  <span className="ml-2 d-none d-lg-inline small font-weight-bold">{adminName}</span>
                </div>
                {dropdownOpen && (
                  <div className="dropdown-menu dropdown-menu-right shadow-lg show border-0" style={{ position: 'absolute', right: 0, top: '100%', marginTop: '0.75rem' }}>
                    <button className="dropdown-item text-danger" onClick={logoutHandler}>
                      <i className="fas fa-sign-out-alt mr-2"></i> Logout
                    </button>
                  </div>
                )}
              </li>
            </ul>
          </nav>
          <div className="px-4 pb-5">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
